export default "__VITE_ASSET__B2BCR1je__"